import React, { Component } from 'react'
import ArrowButton from '../arrowButton'

import './backbutton.scss'
class BackButton extends Component {
  render () {
    let buttonProps = { ...this.props }
    return (
      <div className='element-backbutton'>
        <ArrowButton {...buttonProps} dir='left' />
      </div>
    )
  }
}

BackButton.defaultProps = {
  size: 'l',
  style: 'link',
  round: true,
  spacing: 0
}

BackButton.contextTypes = {
  router: React.PropTypes.object.isRequired
}

export default BackButton



// WEBPACK FOOTER //
// ./src/app/shared/elements/backButton/index.js